import LegacyMediaHandler from './LegacyHandler';
import MediaHandler from './MediaHandler';
import { DeviationTypes } from '../../types/deviation';
/**
 * The media service encapsulates all media/file access to a
 * deviation object.
 *
 * This is a gradual refactor, we are moving various functions into a
 * single interface and then replacing the function calls 1-1.
 *
 * After this we will define a stricter public interface and make the
 * others private. This should give us a clear surface to work on.
 *
 * Once that is done we can add the new handler.
 */
var DeviationMediaService = /** @class */ (function () {
    function DeviationMediaService() {
    }
    DeviationMediaService.prototype.isGif = function (deviation) {
        return this.handleFileOrMedia(deviation).isGif(deviation);
    };
    DeviationMediaService.prototype.getDeviationType = function (deviation) {
        if (!deviation) {
            return DeviationTypes.UNKNOWN;
        }
        return this.handleFileOrMedia(deviation).getDeviationType(deviation);
    };
    DeviationMediaService.prototype.getFullviewForSize = function (deviation, width, height) {
        return this.handleFileOrMedia(deviation).getFullviewForSize(deviation, width, height);
    };
    DeviationMediaService.prototype.getLargestFullview = function (deviation) {
        return this.handleFileOrMedia(deviation).getLargestFullview(deviation);
    };
    DeviationMediaService.prototype.getThumbDimensions = function (deviation) {
        return this.handleFileOrMedia(deviation).getThumbDimensions(deviation);
    };
    DeviationMediaService.prototype.getSmallestThumb = function (deviation) {
        return this.handleFileOrMedia(deviation).getSmallestThumb(deviation);
    };
    DeviationMediaService.prototype.getSmallestThumbThatFullyCovers = function (deviation, width, height, fallback, options) {
        return this.handleFileOrMedia(deviation).getSmallestThumbThatFullyCovers(deviation, width, height, fallback, options);
    };
    /**
     * TODO make this private
     *
     * @param deviation
     * @param fileType
     */
    DeviationMediaService.prototype.getDeviationFile = function (deviation, fileType) {
        return this.handleFileOrMedia(deviation).getDeviationFile(deviation, fileType);
    };
    /**
     * Get default set of thumbs from the deviation
     */
    DeviationMediaService.prototype.getThumbSet = function (deviation, options) {
        return this.handleFileOrMedia(deviation).getThumbSet(deviation, options);
    };
    DeviationMediaService.prototype.getMediaByType = function (deviation, fileType) {
        return this.handleFileOrMedia(deviation).getMediaByType(deviation, fileType);
    };
    DeviationMediaService.prototype.handleFileOrMedia = function (deviation) {
        if (deviation && deviation.media) {
            return new MediaHandler();
        }
        return new LegacyMediaHandler();
    };
    return DeviationMediaService;
}());
export default new DeviationMediaService();
//# sourceMappingURL=DeviationMediaService.js.map